import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Box, Avatar, Tabs, Tab, CircularProgress } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import StarIcon from "@mui/icons-material/Star";

import { Images } from "./../../assets/common";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import QueueMusicIcon from "@mui/icons-material/QueueMusic";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import TipContainer from "./../../components/TipContainer";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { addSongAction } from "./../../action/songs";
import {
  fullName,
  formatedDate,
  isOwner,
  isOwnerId,
  convertHMS,
  copyToClipboard,
  onShare,
  getErrorString,
  getUserDetail,
  putRecors,
  kFormatter,
  hasPremium,
  getShareUrl,
  copyShareUrl,
} from "./../../constants/function";
import SubscriptionPopup from "../../components/SubscriptionPopup";
import BuyBidInfo from "../BuyBidInfo";
import notifier from "../../components/Notifier";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddMusicToPlaylist from "../../components/AddMusicToPlaylist";
import ProfileMenu from "../../components/ProfileMenu";
import OutsideClickHandler from "react-outside-click-handler";
import IosShareIcon from "@mui/icons-material/IosShare";
import { useTranslation } from "react-i18next";
import HMSTag from "../../components/HMS/hms";
import ExplicitBadge from "../../components/ExplicitBadge";
import AIBadge from "../../components/AIBadge";
import SocialProofLine from "../../components/SocialProofLine";
import "./SongDetails.css";

export default function SongDetails() {
  const { t } = useTranslation("common");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const nftId = searchParams.get("nftId");
  const isNft = searchParams.get("nft") === "true";
  const isPlaylistNft = searchParams.get("playlistNft") === "true";
  const referralId = searchParams.get("referralId");
  const userData = getUserDetail();
  const songs = useSelector((state) => state.songs);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [musicDetail, setMusicDetail] = useState({});
  const [buyBid, setBuyBid] = useState(false);
  const { id } = useParams();
  const history = useHistory();
  const [openAlbumMenu, setAlbumMenu] = React.useState(false);
  const [showPlaylist, setShowPlaylist] = React.useState(false);
  const [selectedId, setSelectedAlbum] = React.useState();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [open, setOpen] = useState(false);
  const [isAlbum, setIsAlbum] = React.useState(false);
  const [index, setIndex] = React.useState(-1);
  const [owners, setOwners] = useState([]);
  const [nftDetail, setNftDetails] = useState({});
  const [option, setOption] = React.useState(false);

  // New state for redesigned page
  const [activeTab, setActiveTab] = useState(0);
  const [playlists, setPlaylists] = useState([]);
  const [topStreamers, setTopStreamers] = useState([]);
  const [videos, setVideos] = useState([]);
  const [loadingExtra, setLoadingExtra] = useState(false);
  const [showSubPopup, setShowSubPopup] = useState(false);
  const isPro = hasPremium();

  const getThumbnail = () => {
    if (musicDetail["thumbnailImg"]) return musicDetail["thumbnailImg"]["filePath"];
    if (musicDetail["GIF"]) return musicDetail["GIF"]["filePath"];
    return "";
  };

  const getArtistName = () => {
    if (musicDetail.artistData && musicDetail.artistData.length > 0) {
      const names = musicDetail.artistData.map(a => a?.displayArtistName).filter(Boolean);
      if (names.length > 0) return names.join(", ");
    }
    if (musicDetail["artist"] && !/^[0-9a-f]{24}$/i.test(musicDetail["artist"])) return musicDetail["artist"];
    if (musicDetail["owner"] && typeof musicDetail["owner"] === "object") return fullName(musicDetail["owner"]);
    if (musicDetail["uploader"] && typeof musicDetail["uploader"] === "object") return fullName(musicDetail["uploader"]);
    return "";
  };

  const fetchExtraData = async (musicId) => {
    setLoadingExtra(true);
    try {
      const [playlistsRes, streamersRes, videosRes] = await Promise.all([
        ApiService.PLAYLISTS_BY_SONG(musicId).catch((e) => { console.error("PLAYLISTS_BY_SONG error:", e); return null; }),
        ApiService.TOP_STREAMERS_FOR_SONG(musicId, 10).catch((e) => { console.error("TOP_STREAMERS error:", e); return null; }),
        ApiService.VIDEOS_BY_SONG(musicId).catch((e) => { console.error("VIDEOS_BY_SONG error:", e); return null; }),
      ]);
      if (playlistsRes?.result) setPlaylists(playlistsRes.result);
      if (streamersRes?.result) setTopStreamers(streamersRes.result);
      if (videosRes?.result) setVideos(videosRes.result);
    } catch (e) {
      console.error("Error fetching extra data:", e);
    } finally {
      setLoadingExtra(false);
    }
  };

  const getMusicDetail = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.MUSIC_DETAIL(_id);
      setMusicDetail({ ...response["result"] });
      fetchExtraData(_id);
      if (window.location.href.includes("referralId="))
        putRecors({
          id: userData._id,
          referralLink: window.location.href,
          eventType: ["sharedInbound"],
          eventAsset: response["result"]?._id,
          eventValue: ["Music"],
          socialMedia: null,
          referralId: referralId,
        });
      else
        putRecors({
          id: userData._id,
          referralLink: window.location.href,
          eventType: ["view"],
          eventAsset: response["result"]?._id,
          eventValue: ["Music"],
          socialMedia: null,
        });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (
        getErrorString(error) ===
        "This is an explicit content you need to be above 18 to view it"
      ) {
        notifier.error(getErrorString(error));
        history.push("/app/Home");
      }
    }
  };
  const getNftDetails = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.NFT_BY_ID(_id);
      const detail = response["result"];
      if (response["result"] && !response["result"]["playlistDetails"])
        setOwners([...response["result"]]);
      if (response["result"])
        detail["nftDetails"] = {
          onAuction: response["result"][0]["onAuction"],
          onSale: response["result"][0]["onSale"],
          sellingPrice: response["result"][0]["sellingPrice"],
        };
      detail["nftId"] = _id;
      setNftDetails({ ...response["result"][0] });
      setMusicDetail({ ...detail, ...response["result"][0]["musicDetails"] });
      fetchExtraData(response["result"][0]["musicDetails"]?.["_id"] || _id);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  React.useEffect(() => checkForSell(), [owners]);
  const checkForSell = () => {
    for (let index = 0; index < owners.length; index++) {
      if (
        !isOwnerId(owners[index]["owner"]["_id"]) &&
        owners[index]["onSale"]
      ) {
        setIndex(index);
        return;
      }
    }
    setIndex(-1);
  };
  const getPlaylistNftDetails = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_NFT_BY_ID(_id);
      const detail = response["result"];
      if (response["result"])
        detail["nftDetails"] = {
          onAuction: response["result"]["onAuction"],
          onSale: response["result"]["onSale"],
          sellingPrice: response["result"]["sellingPrice"],
        };
      detail["nftId"] = _id;
      detail["isPlaylistNft"] = true;
      setMusicDetail({ ...detail, ...response["result"]["playlistDetails"] });
      fetchExtraData(response["result"]["playlistDetails"]?.["_id"] || _id);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const play = () => {
    if (id && isNft) {
      if (!nftDetail["isSubscribed"] && nftDetail["private"])
        notifier.error(t("notifier.error.toast15"));
      else dispatch(addSongAction(musicDetail));
    } else if (
      musicDetail["uploader"] &&
      !musicDetail["uploader"]["isSubscribed"] &&
      musicDetail["private"]
    )
      notifier.error(t("notifier.error.toast15"));
    else dispatch(addSongAction(musicDetail));
  };
  useEffect(() => {
    if (nftId)
      history.replace(`/app/SongDetails/${nftId}?nft=true&referralId=${referralId}`);
    else if (id && isPlaylistNft)
      getPlaylistNftDetails(id);
    else if (id && isNft)
      getNftDetails(id);
    else if (id)
      getMusicDetail(id);
  }, [id]);

  const flaguser = async () => {
    try {
      setLoading(true);
      const response = await ApiService.FLAG_USER({
        message: "Reason",
        assetId: musicDetail["_id"],
        verify: musicDetail["uploader"]
          ? musicDetail["uploader"]["_id"]
          : musicDetail["owner"]["_id"],
      });
      notifier.success(t("notifier.success.toast4"));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const toggleMenu = (value, id, index) => {
    setOpen(false);
    setAlbumMenu(false);
    setSelectedAlbum(id);
    setSelectedIndex(index);

    if (value && id) makeAction(value, id);
    else if (value) makeAction(value);
  };

  const makeAction = (key, id) => {
    if (
      musicDetail["uploader"] &&
      !musicDetail["uploader"]["isSubscribed"] &&
      musicDetail["private"]
    )
      notifier.error(t("notifier.error.toast15"));
    else
      switch (key) {
        case "m3":
          setIsAlbum(false);
          setShowPlaylist(true);
          break;
        case "m4":
          setIsAlbum(true);
          setShowPlaylist(true);
          break;
      }
  };
  const handleCopy = async (action) => {
    if (action === "m14") {
      try {
        await copyShareUrl('song', musicDetail._id);
        notifier.success("Link copied to clipboard!");
      } catch (e) {
        console.error('Copy failed:', e);
      }
      return;
    }

    const url = await getShareUrl('song', musicDetail._id);

    switch (action) {
      case "m15":
        onShare(action, url, {
          id: userData._id,
          referralLink: url,
          eventType: ["sharedOutbound"],
          eventAsset: musicDetail?._id,
          sharedBy: fullName(userData),
          eventValue: ["Music"],
          socialMedia: "facebook",
        });
        break;
      case "m16":
        onShare(action, url, {
          id: userData._id,
          referralLink: url,
          eventType: ["sharedOutbound"],
          eventAsset: musicDetail?._id,
          sharedBy: fullName(userData),
          eventValue: ["Music"],
          socialMedia: "twitter",
        });
        break;
      case "Share on Instagram":
        onShare(action, url);
        break;

      default:
        break;
    }
  };
  const handleClick = (event) => {
    setOption(!option);
    putRecors({
      id: userData._id,
      referralLink: window.location.href,
      eventType: ["click"],
      eventAsset: musicDetail?._id,
      sharedBy: fullName(userData),
      eventValue: ["Music"],
      socialMedia: null,
    });
  };
  const handleClose = () => {
    setOption(false);
  };

  // ─── HELPERS ───────────────────────────────────────────────────────────
  const artistId = musicDetail["owner"]?._id || musicDetail["uploader"]?._id;
  const showTip = (musicDetail["owner"] || musicDetail["uploader"]) &&
    !isOwnerId(musicDetail["owner"]?.["_id"] || musicDetail["uploader"]?.["_id"] || (typeof musicDetail["uploader"] === "string" ? musicDetail["uploader"] : "")) &&
    musicDetail.nftId;
  const rankClass = (i) => i === 0 ? "sd-rank-badge--gold" : i === 1 ? "sd-rank-badge--silver" : i === 2 ? "sd-rank-badge--bronze" : "sd-rank-badge--default";

  // ─── RENDER ────────────────────────────────────────────────────────────
  return (
    <div className="sd-page">
      {musicDetail["_id"] ? (
        <>
          {/* ── Hero ────────────────────────────────────────────────── */}
          <div className="sd-hero">
            <div className="sd-hero-bg"><img src={getThumbnail()} alt="" /></div>
            <div className="sd-back" onClick={() => history.goBack()}>
              <ArrowBackIosIcon /> Back
            </div>
            <div className="sd-hero-content">
              <img className="sd-hero-cover" src={getThumbnail()} alt={musicDetail["title"]} />
              <div className="sd-hero-info">
                <div className="sd-title-row">
                  <span className="sd-title">{musicDetail["title"]}</span>
                  <AIBadge show={musicDetail["isAIGenerated"]} size="large" />
                  <ExplicitBadge show={musicDetail["isExplicit"]} size="large" />
                </div>

                <span className="sd-artist" onClick={() => artistId && history.push(`/app/ArtistProfile/${artistId}`)}>
                  {getArtistName()}
                </span>

                <SocialProofLine type={isAlbum ? "album" : "music"} id={musicDetail["_id"]} sx={{ mt: 0.5 }} />

                <div className="sd-stat-row">
                  <div className="sd-stat-card">
                    <HeadphonesIcon className="sd-stat-icon" />
                    <div>
                      <div className="sd-stat-value">{kFormatter(musicDetail["listens"] || 0)}</div>
                      <div className="sd-stat-label">Streams</div>
                    </div>
                  </div>
                  {musicDetail["duration"] ? (
                    <div className="sd-stat-card">
                      <AccessTimeIcon className="sd-stat-icon" />
                      <div>
                        <HMSTag duration={musicDetail["duration"]} />
                        <div className="sd-stat-label">Duration</div>
                      </div>
                    </div>
                  ) : null}
                  {musicDetail["genreData"]?.[0]?.title ? (
                    <div className="sd-stat-card">
                      <QueueMusicIcon className="sd-stat-icon" />
                      <div>
                        <div className="sd-stat-value">{musicDetail["genreData"][0].title}</div>
                        <div className="sd-stat-label">Genre</div>
                      </div>
                    </div>
                  ) : null}
                  {musicDetail["nftId"] ? <div className="sd-collectable-badge">Collectable</div> : null}
                </div>

                <div className="sd-actions">
                  {musicDetail["fileId"] ? (
                    <button className="sd-btn-play" onClick={() => play()}>
                      <PlayArrowRoundedIcon /> Play
                    </button>
                  ) : null}

                  {musicDetail["fileId"] ? (
                    <div style={{ position: "relative" }}>
                      <div className="sd-btn-more" onClick={(e) => { e.stopPropagation(); setAlbumMenu(!openAlbumMenu); }}>
                        <MoreVertIcon sx={{ fontSize: 18 }} />
                      </div>
                      {openAlbumMenu ? (
                        <OutsideClickHandler onOutsideClick={() => setAlbumMenu(false)}>
                          <ProfileMenu
                            isMenu={open}
                            actions={[
                              { key: "m3", action: t("dropMenu.m3") },
                              isOwnerId(musicDetail?.uploader?._id) ? { key: "m4", action: t("dropMenu.m4") } : "",
                            ]}
                            handleProfileMenuChoice={(action) => toggleMenu(action, musicDetail._id, null)}
                          />
                        </OutsideClickHandler>
                      ) : null}
                    </div>
                  ) : null}

                  <div style={{ position: "relative" }}>
                    <button className="sd-btn-share" onClick={handleClick}>
                      <IosShareIcon /> Share
                    </button>
                    {option ? (
                      <OutsideClickHandler onOutsideClick={() => handleClose()}>
                        <ProfileMenu
                          right="0px" isHeader={true} isLast="40px"
                          actions={[
                            { key: "m14", action: t("dropMenu.m14") },
                            { key: "m15", action: t("dropMenu.m15") },
                            { key: "m16", action: t("dropMenu.m16") },
                          ]}
                          handleProfileMenuChoice={(key) => (handleCopy(key), handleClose())}
                        />
                      </OutsideClickHandler>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ── Tabs ────────────────────────────────────────────────── */}
          <div className="sd-tabs-wrapper">
            <Tabs
              value={activeTab}
              onChange={(e, v) => setActiveTab(v)}
              sx={{
                "& .MuiTabs-indicator": { backgroundColor: "#ffee20" },
                "& .MuiTab-root": { color: "rgba(255,255,255,0.5)", textTransform: "none", fontWeight: 500, fontSize: 14, minHeight: 44 },
                "& .Mui-selected": { color: "#fff !important" },
              }}
            >
              <Tab label="Overview" />
            </Tabs>
          </div>

          {/* ── Content + Sidebar ───────────────────────────────────── */}
          <div className="sd-layout">
            <div className="sd-main">
              {activeTab === 0 && (
                <>
                  {musicDetail["description"] ? (
                    <p className="sd-description">{musicDetail["description"]}</p>
                  ) : null}

                  {/* Playlists */}
                  {playlists.length > 0 && (
                    <div className="sd-section">
                      <div className="sd-section-header">
                        <h3 className="sd-section-title">Playlists</h3>
                        {!isPro && (
                          <span className="sd-pro-tag">
                            <StarIcon sx={{ fontSize: 14 }} /> PRO
                          </span>
                        )}
                      </div>
                      <div className={`sd-pro-container ${!isPro ? "sd-pro-container--locked" : ""}`}>
                        <div className={!isPro ? "sd-pro-blur-wrap" : undefined}>
                          <div className="sd-table-header">
                            <span className="sd-th" style={{ width: 32, textAlign: "center" }}>#</span>
                            <span className="sd-th" style={{ flex: 1, marginLeft: 12 }}>Title</span>
                            <span className="sd-th" style={{ width: 80, textAlign: "center" }}>Songs</span>
                            <span className="sd-th" style={{ width: 100, textAlign: "right" }}>Streams</span>
                          </div>
                          {playlists.slice(0, isPro ? 10 : 5).map((pl, idx) => (
                            <div key={pl._id} className="sd-playlist-row" onClick={() => isPro && history.push(`/app/Music/${pl._id}`)}>
                              <span className="sd-playlist-num">{idx + 1}</span>
                              <img className="sd-playlist-thumb" src={pl.thumbnailImg?.filePath || pl.GIF?.filePath || ""} alt="" />
                              <span className="sd-playlist-title">{pl.title}</span>
                              <span className="sd-playlist-meta" style={{ width: 80, textAlign: "center" }}>{pl.songCount}</span>
                              <span className="sd-playlist-meta" style={{ width: 100, textAlign: "right" }}>{kFormatter(pl.songStreams)}</span>
                            </div>
                          ))}
                        </div>
                        {!isPro && (
                          <div className="sd-pro-overlay" onClick={() => setShowSubPopup(true)}>
                            <div className="sd-pro-overlay-content">
                              <div className="sd-pro-lock-icon">
                                <LockIcon sx={{ fontSize: 28 }} />
                              </div>
                              <p className="sd-pro-overlay-title">Unlock Top Playlists</p>
                              <p className="sd-pro-overlay-desc">See which playlists feature this track</p>
                              <button className="sd-pro-upgrade-btn">
                                <StarIcon sx={{ fontSize: 16 }} /> Upgrade to Pro
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Top Streamers */}
                  {topStreamers.length > 0 && (
                    <div className="sd-section">
                      <div className="sd-section-header">
                        <h3 className="sd-section-title">Top Streamers</h3>
                        {!isPro && (
                          <span className="sd-pro-tag">
                            <StarIcon sx={{ fontSize: 14 }} /> PRO
                          </span>
                        )}
                      </div>
                      <div className={`sd-pro-container ${!isPro ? "sd-pro-container--locked" : ""}`}>
                        <div className={!isPro ? "sd-pro-blur-wrap" : undefined}>
                          {topStreamers.slice(0, isPro ? 10 : 5).map((s, idx) => (
                            <div
                              key={idx}
                              className="sd-streamer-row"
                              onClick={() => isPro && s.user?._id && history.push(`/app/ArtistProfile/${s.user._id}`)}
                            >
                              <div className={`sd-rank-badge ${rankClass(idx)}`}>{idx + 1}</div>
                              <Avatar
                                src={s.user?.profileImg?.filePath}
                                className={`sd-streamer-avatar ${idx < 3 ? "sd-streamer-avatar--top" : ""}`}
                                sx={{ width: 38, height: 38 }}
                              />
                              <span className="sd-streamer-name">
                                {s.user?.displayArtistName || fullName(s.user) || "Anonymous"}
                              </span>
                              <span className="sd-streamer-count">
                                <HeadphonesIcon /> {kFormatter(s.streamCount)}
                              </span>
                            </div>
                          ))}
                        </div>
                        {!isPro && (
                          <div className="sd-pro-overlay" onClick={() => setShowSubPopup(true)}>
                            <div className="sd-pro-overlay-content">
                              <div className="sd-pro-lock-icon">
                                <LockIcon sx={{ fontSize: 28 }} />
                              </div>
                              <p className="sd-pro-overlay-title">Unlock Top Streamers</p>
                              <p className="sd-pro-overlay-desc">See who's streaming this track the most</p>
                              <button className="sd-pro-upgrade-btn">
                                <StarIcon sx={{ fontSize: 16 }} /> Upgrade to Pro
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Videos */}
                  {videos.length > 0 && (
                    <div className="sd-section">
                      <h3 className="sd-section-title">Videos</h3>
                      <div className="sd-video-grid">
                        {videos.slice(0, 6).map((v) => (
                          <div key={v._id} className="sd-card" onClick={() => history.push(`/app/video-player/${v.studioId || "none"}/${v._id}`)}>
                            <div className="sd-card-thumb">
                              <img src={v.thumbnail?.url || ""} alt={v.title} />
                            </div>
                            <div className="sd-card-body">
                              <div className="sd-card-title">{v.title}</div>
                              <div className="sd-card-meta">{kFormatter(v.views)} views</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Empty state */}
                  {!loadingExtra && playlists.length === 0 && topStreamers.length === 0 && videos.length === 0 && !musicDetail["description"] && (
                    <div className="sd-empty-state">
                      <QueueMusicIcon className="sd-empty-icon" />
                      <p className="sd-empty-text">No additional content available for this song yet.</p>
                    </div>
                  )}

                  {loadingExtra && (
                    <div className="sd-loading">
                      <CircularProgress size={28} sx={{ color: "#ffee20" }} />
                    </div>
                  )}

                  {/* Tip */}
                  {showTip ? (
                    <div style={{ marginBottom: 24 }}>
                      <TipContainer
                        isArtist={true}
                        artistName={fullName(musicDetail["owner"] || musicDetail["uploader"] || "")}
                        id={musicDetail["owner"]?.["_id"] || musicDetail["uploader"]?.["_id"] || ""}
                      />
                    </div>
                  ) : null}

                </>
              )}

            </div>

            {/* ── Sidebar ───────────────────────────────────────────── */}
            <div className="sd-sidebar">
              {/* Details */}
              <div className="sd-sidebar-card">
                <div className="sd-sidebar-card-title">Details</div>

                {getArtistName() ? (
                  <div className="sd-detail-row">
                    <div className="sd-detail-label">Artist</div>
                    <div className="sd-detail-value">{getArtistName()}</div>
                  </div>
                ) : null}

                {musicDetail["releaseDate"] ? (
                  <div className="sd-detail-row">
                    <div className="sd-detail-label">Release Date</div>
                    <div className="sd-detail-value">{formatedDate(musicDetail["releaseDate"])}</div>
                  </div>
                ) : null}

                {musicDetail["ISRCCode"] ? (
                  <div className="sd-detail-row">
                    <div className="sd-detail-label">ISRC Code</div>
                    <div className="sd-detail-value sd-detail-mono">{musicDetail["ISRCCode"]}</div>
                  </div>
                ) : null}

                {!musicDetail["playlistDetails"] && musicDetail["isAIGenerated"] ? (
                  <div className="sd-detail-row">
                    <div className="sd-detail-label">AI Generated</div>
                    <div className="sd-detail-value">Yes</div>
                  </div>
                ) : null}

                {!musicDetail["playlistDetails"] ? (
                  <div className="sd-detail-row">
                    <div className="sd-detail-label">Explicit</div>
                    <div className="sd-detail-value">{musicDetail["isExplicit"] ? "Yes" : "No"}</div>
                  </div>
                ) : null}

                {musicDetail["collaborators"]?.length > 0 ? (
                  <div className="sd-detail-row">
                    <div className="sd-detail-label">Collaborators</div>
                    {musicDetail["collaborators"].map((c, i) => (
                      <div key={i} className="sd-collab-row">
                        <span className="sd-collab-role">{c["role"]}</span>
                        <span className="sd-collab-name">{fullName(c["_id"])}</span>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>

              {/* Royalties */}
              {(musicDetail["royalties"]?.length > 0 || musicDetail["ownerRoyalty"]) ? (
                <div className="sd-sidebar-card sd-sidebar-card--gold">
                  <div className="sd-sidebar-card-title">Royalties</div>

                  {musicDetail["ownerRoyalty"] ? (
                    <div className="sd-royalty-row">
                      <div className="sd-royalty-header">
                        <span className="sd-royalty-name">
                          <span className="sd-royalty-dot sd-royalty-dot--primary" />
                          {fullName(musicDetail["uploader"] || "")}
                        </span>
                        <span className="sd-royalty-pct sd-royalty-pct--primary">{musicDetail["ownerRoyalty"]}%</span>
                      </div>
                      <div className="sd-royalty-bar">
                        <div className="sd-royalty-fill sd-royalty-fill--primary" style={{ width: `${musicDetail["ownerRoyalty"]}%` }} />
                      </div>
                    </div>
                  ) : null}

                  {musicDetail["royalties"]?.map((r, i) => (
                    <div key={i} className="sd-royalty-row">
                      <div className="sd-royalty-header">
                        <span className="sd-royalty-name">
                          <span className="sd-royalty-dot sd-royalty-dot--secondary" />
                          {fullName(r["_id"])}
                        </span>
                        <span className="sd-royalty-pct sd-royalty-pct--secondary">{r["percentage"]}%</span>
                      </div>
                      <div className="sd-royalty-bar">
                        <div className="sd-royalty-fill sd-royalty-fill--secondary" style={{ width: `${r["percentage"]}%` }} />
                      </div>
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          </div>
        </>
      ) : null}

      {buyBid ? (
        <Box className="__buy_bid_info" sx={{ borderRadius: "6px" }}>
          <BuyBidInfo
            id={musicDetail["nftId"] || musicDetail["_id"]}
            isPlaylistNft={musicDetail["isPlaylistNft"]}
            handleBack={() => setBuyBid(false)}
          />
        </Box>
      ) : null}
      {loading ? <Loader /> : null}
      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={musicDetail["_id"]}
          isAlbum={isAlbum}
          open={showPlaylist}
          handleClose={() => setShowPlaylist(false)}
        />
      ) : null}
      {showSubPopup ? (
        <SubscriptionPopup
          isOpen={showSubPopup}
          onClose={() => setShowSubPopup(false)}
        />
      ) : null}
    </div>
  );
}
